<script lang="ts" setup>
import { computed, ref } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import EmptyMsg from '@core/assets/image/common/hetao-empty-msg.svg';
import iconNotificationWhite from '@core/assets/image/icon/icon-notification-white.svg';
import iconNotification from '@core/assets/image/icon/icon-notification.svg';
import { MessageService } from '@core/services/message.service';
import { timeSweetFormat2 } from '@core/utils/dayjs';
import HTNotificationTitle from './HTNotificationTitle.vue';

const conRef = ref();
const service = useService(MessageService);
const props = defineProps<{ white?: boolean }>();

const popoverStyle: any = {
  maxHeight: '512px',
  overflowY: 'auto',
};

const iconUrl = computed(() =>
  props.white ? iconNotificationWhite : iconNotification,
);
</script>

<template>
  <div ref="conRef">
    <a-popover
      placement="bottomRight"
      trigger="click"
      :overlay-inner-style="popoverStyle"
      :get-popup-container="() => conRef"
      :align="{
        offset: [0, 5],
      }"
      @open-change="service.handleOpenChange"
    >
      <div
        v-track:oj_notification_icon_click.click
        class="h-6 w-6 cursor-pointer rounded-sm hover:opacity-75"
      >
        <a-badge :dot="service.showDot" :offset="[-3, 3]">
          <img class="h-6 w-6" :src="iconUrl" alt="icon" />
        </a-badge>
      </div>

      <template #content>
        <div class="w-[340px] p-2">
          <div v-if="service.list.length === 0">
            <div
              class="flex h-32 items-center justify-center text-base text-[#ccc]"
            >
              <a-empty
                :image="EmptyMsg"
                :image-style="{ height: '100px' }"
                description="暂无消息"
              />
            </div>
          </div>
          <ul>
            <li
              v-for="item in service.list"
              :key="item.id"
              v-track:element_show="service.getMsgShowEvent(item)"
              class="text-title mb-4 flex cursor-pointer items-center justify-between gap-4 border-b border-[#F1F1F1] pb-4 last:mb-0 last:border-none last:pb-0"
              @click="service.handleClickMessage(item)"
            >
              <div class="w-0 flex-1">
                <HTNotificationTitle :msg="item" />
                <a-tooltip :title="item.posterName">
                  <div class="text-subtitle truncate">
                    <span
                      v-if="item.messageType === 15"
                      class="text-font1 mr-1 font-bold"
                      >[认证中]</span
                    >
                    <span
                      v-if="item.messageType === 16"
                      class="text-success mr-1 font-bold"
                      >[认证通过]</span
                    >
                    <span
                      v-if="item.messageType === 17"
                      class="text-error mr-1 font-bold"
                      >[认证失败]</span
                    >
                    <span class="text-font2">{{ item.posterName }}</span>
                  </div>
                </a-tooltip>
              </div>
              <div class="text-subtitle w-[84px] flex-shrink-0 text-right">
                {{ timeSweetFormat2(item.messageTime as number) }}
              </div>
            </li>
          </ul>
        </div>
      </template>
    </a-popover>
  </div>
</template>

<style scoped></style>
